<template>
  <hr class="border-1 border-surface-secondary" aria-hidden="true" />
  <AppAccordion
    type="link-no-border"
    :only-mobile="false"
    :is-open="configData.DefaultOpen"
  >
    <template #header>
      <p v-if="!configData.IsHeaderTag" class="heading-xxs">
        {{ configData.Title }}
      </p>
      <h2 v-else class="heading-xxs">{{ configData.Title }}</h2>
    </template>
    <MarkupGenerator
      :page-data="{ PageContent: [...configData.innerMarkup] as any }"
      :is-page="false"
    />
  </AppAccordion>
  <hr class="border-1 border-surface-secondary" aria-hidden="true" />
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Title?: string;
    IsHeaderTag?: boolean;
    DefaultOpen?: boolean;
    innerMarkup?: any;
  };
}

defineProps<Props>();
</script>
